import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {IIngredientCategory} from '../../interfaces/database/database.interface';
import {NzSelectComponent} from 'ng-zorro-antd/select';
import {firstValueFrom, Observable} from 'rxjs';
import {Store} from '@ngxs/store';
import {IIngredient, IngredientsAction, IngredientState} from '../../models/ingredient';
import {IFoodGroupIngredient} from '../../models/food-group';
import {cloneDeep} from 'lodash';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {IngredientCalculationService} from '../../services/ingredient-calculation/ingredient-calculation.service';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {FoodGroupService} from '../../services/food-group/food-group.service';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'app-ingredient-selector',
  templateUrl: './ingredient-selector.component.html',
  styleUrls: ['./ingredient-selector.component.scss'],
  animations: [fadeInAnimation]
})
export class IngredientSelectorComponent implements OnInit, OnChanges {
  @Input() disabled = false;
  @Input() hasCategoryFilter: boolean;
  @Input() excludedIngredients: string[] = [];
  @Input() hasIngredientName: boolean;
  @Input() showForm: boolean;
  @Input() resetAfterSelect = true;
  @Input() searchOnOpen = false;
  @Output() cancel: EventEmitter<boolean> = new EventEmitter();
  @Output() selected: EventEmitter<Partial<IFoodGroupIngredient>> = new EventEmitter();
  @ViewChild('categoryIngredientSelectInput') categoryIngredientSelect: NzSelectComponent;
  @ViewChild('ingredientForm') ingredientForm: NgForm;
  ingredients$: Observable<IIngredient[]> = this.store.select<IIngredient[]>(IngredientState.getIngredients);
  categoryIngredientMode = false;
  ingredientCategories: IIngredientCategory[] = [];
  selectedIngredientCategories: IIngredientCategory[] = [];
  selectedIngredientCategoriesIds: string[] = [];
  ingredients: IIngredient[];
  selectedIngredient: IIngredient;
  // Variables para la búsqueda de ingredientes
  batchSizeIngredients = 20;
  totalBatchesIngredient = 0;
  ingredientNameSearch: string;
  isLoadingIngredients = false;
  isLoadingFirstIngredients = false;
  searchIntervalIngredient: any;
  finishSearchIngredients = false;
  searchIngredientPreviewValue = '';
  constructor(
    private store: Store,
    private ingredientCalculationService: IngredientCalculationService,
    private messageAlertService: MessageAlertService,
    private foodGroupService: FoodGroupService,
  ) {
    this.defaultDataIngredient();
  }

  ngOnInit(): void {
    this.initializeIngredientVariables().then();
    this.searchIngredientPreviewValue = '';
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (!changes.ingredient) return;
    // Llenar formulario a editar
  }

  /**
   * Inicializa las variables para los ingredientes
   */
  async initializeIngredientVariables(): Promise<void> {
    await firstValueFrom(this.store.dispatch(new IngredientsAction.GetCategories()));
    this.ingredientCategories = cloneDeep(await firstValueFrom(this.store.selectOnce(IngredientState.getIngredientCategories)));
    // Asignar colores a las categorías de los ingredientes
    this.ingredientCategories.forEach((category: IIngredientCategory) => {
      category.color = this.foodGroupService.setIngredientCategoryColor(category.name);
    });
    this.ingredients = cloneDeep(await firstValueFrom(this.store.selectOnce(IngredientState.getIngredients)));
  }

  defaultDataIngredient(): void {
    this.selectedIngredient = cloneDeep({
      ingredientId: null,
      ingredientName: null,
      measure: {
        _id: null
      },
      units: 1,
      category: null,
      nutritionalProperties: null
    });
  }

  /**
   * Al cambiar el valor del select múltiple de categorías de ingredientes
   */
  onSelectIngredientCategories(categoryIds: string[]): void {
    this.selectedIngredientCategories = [];
    categoryIds.forEach((tagId: string) => {
      const index: number = this.ingredientCategories.findIndex((category: IIngredientCategory) => category._id === tagId);
      if (index !== -1) {
        this.selectedIngredientCategories.push(this.ingredientCategories[index]);
        this.categoryIngredientSelect.setOpenState(false);
      }
    });
  }

  /**
   * Método para remover una categoría de los ingredientes
   */
  async onRemoveIngredientCategory(id: string): Promise<void> {
    const index = this.selectedIngredientCategories.findIndex((cat: IIngredientCategory) => cat._id === id);
    if (index !== -1) {
      this.selectedIngredientCategories.splice(index, 1);
      this.selectedIngredientCategoriesIds.splice(index, 1);
      // Actualizar la lista de ingredientes
      // await this.getFirstIngredientBatch();
    }
  }



  /**
   * Método para habilitar/deshabilitar el select para elegir categorías de ingredientes
   */
  async onToggleCategoryIngredientEditMode(mode: boolean): Promise<void> {
    this.categoryIngredientMode = mode;
    if (!mode) {
      // Actualizar la lista de ingredientes
      // await this.getFirstIngredientBatch();
      return;
    }
    setTimeout(() => {
      if (this.categoryIngredientSelect) {
        this.categoryIngredientSelect.setOpenState(true);
      }
    }, 200);
  }

  /**
   * Obtiene el primer lote de ingredientes (para el select)
   */
  async getFirstIngredientBatch(): Promise<void> {
    this.totalBatchesIngredient = 0;
    this.finishSearchIngredients = false;
    const categoryId: string = this.selectedIngredientCategoriesIds?.length > 0 ? this.selectedIngredientCategoriesIds[0] : '';
    await firstValueFrom((this.store.dispatch(new IngredientsAction.Get('', categoryId))));
  }

  /**
   * Trae los resultados de búsqueda para los ingredientes
   * @param $event evento de búsqueda del input
   */
  async onSearchIngredient($event): Promise<void> {
    if (this.searchOnOpen) {
      this.searchIngredientPreviewValue = 'something';
    }
    // Evitar que haga una petición la primera vez que se abre el select
    if (!this.searchIngredientPreviewValue) {
      this.searchIngredientPreviewValue = 'something';
      if (this.selectedIngredient) {
        this.store.dispatch(new IngredientsAction.RemoveSelectedUserListIngredient());
      }
      return;
    }
    // Búsqueda
    this.searchIngredientPreviewValue = $event;
    this.isLoadingFirstIngredients = true;
    if (this.searchIntervalIngredient) {
      clearInterval(this.searchIntervalIngredient);
    }
    this.searchIntervalIngredient = setTimeout(async () => {
      this.finishSearchIngredients = false;
      this.ingredientNameSearch = $event;
      const categoryId: string = this.selectedIngredientCategoriesIds?.length > 0 ? this.selectedIngredientCategoriesIds[0] : '';
      await firstValueFrom((this.store.dispatch(new IngredientsAction.Get(this.ingredientNameSearch, categoryId))));
      this.isLoadingFirstIngredients = false;
    }, 400);
  }

  /**
   * Guarda el valor seleccionado
   * @param id id del ingrediente
   */
  async onChooseIngredient(id: string): Promise<void> {
    try {
      this.ingredients = cloneDeep(await firstValueFrom((this.store.selectOnce(IngredientState.getIngredients))));
      const ingredients: IIngredient[] = [...this.ingredients];
      const index: number = ingredients.findIndex((ingredient: IIngredient) => ingredient._id === id);
      if (index === -1) return;
      this.selectedIngredient = cloneDeep(ingredients[index]);
      this.selected.emit(cloneDeep(this.selectedIngredient));
      if (this.resetAfterSelect) {
        this.defaultDataIngredient();
        this.ingredientForm.resetForm();
      }
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Guardar automáticamente las categorías del select al cerrar las opciones
   * @param action true para abrir, falso para cerrar
   */
  async onOpenChangeCategoriesSelect(action: boolean): Promise<void> {
    if (action) return;
    await this.onToggleCategoryIngredientEditMode(false);
  }
}
